import { ActivityStatusOptions } from './calendarModels';
import {
  PraksisgruppeDto,
  PraksiskalenderAktivitetDto,
} from '../api/generated/praksissted-generated-api';

const practicePeriodsByActivityStatusFilter =
  (activityStatusFilter: string) => (activity: PraksiskalenderAktivitetDto) => {
    switch (activityStatusFilter) {
      case ActivityStatusOptions.ACTIVITIES_NOT_SHARED:
        return !activity.bekreftet;
      case ActivityStatusOptions.ACTIVITIES_MISSING_CAPACITY:
        return activity.bekreftet && activity.kapasitet < activity.behov;
      case ActivityStatusOptions.ACTIVITIES_FILLED_CAPACITY:
        return activity.bekreftet && activity.kapasitet >= activity.behov;
    }
  };

export const practiceActivitiesFilter = (
  practiceActivitiesPerClass: {
    [klasseId: string]: PraksiskalenderAktivitetDto[];
  },
  activityStatusFilter: string,
): { [klasseId: string]: PraksiskalenderAktivitetDto[] } => {
  if (
    activityStatusFilter === ActivityStatusOptions.ALL_ACTIVITIES ||
    activityStatusFilter === ActivityStatusOptions.UNFILTERED
  ) {
    return practiceActivitiesPerClass;
  }

  const practiceActivitiesFiltered: {
    [key: string]: PraksiskalenderAktivitetDto[];
  } = {};

  Object.keys(practiceActivitiesPerClass).forEach((klasseId) => {
    const practicePeriods = practiceActivitiesPerClass[klasseId];
    const filtered = practicePeriods.filter(
      practicePeriodsByActivityStatusFilter(activityStatusFilter),
    );
    if (filtered.length > 0) {
      practiceActivitiesFiltered[klasseId] = filtered;
    }
  });
  return practiceActivitiesFiltered;
};

function searchHit(s: string, searchPhrase: string): boolean {
  return s.toLocaleLowerCase().indexOf(searchPhrase) >= 0;
}

export const practiceGroupsFilter = (
  practiceActivitiesFiltered: {
    [klasseId: string]: PraksiskalenderAktivitetDto[];
  },
  praksisgrupper: PraksisgruppeDto[],
  searchPhrase: string,
) => {
  return praksisgrupper
    .map((practiceGroup) => {
      const phraseLowerCase = searchPhrase.toLocaleLowerCase();
      const practiceTypeMatch = searchHit(
        practiceGroup.praksis.navn,
        phraseLowerCase,
      );
      const instFiltered = practiceGroup.institusjoner
        .map((institustion) => {
          const institustionMatch = searchHit(
            institustion.institusjonsnavn,
            phraseLowerCase,
          );
          return {
            ...institustion,
            klasser: institustion.klasser.filter((klasse) => {
              return (
                klasse.id in practiceActivitiesFiltered &&
                (practiceTypeMatch ||
                  institustionMatch ||
                  searchHit(klasse.emne.navn, phraseLowerCase))
              );
            }),
          };
        })
        .filter((it) => it.klasser.length > 0);
      return {
        ...practiceGroup,
        institusjoner: instFiltered,
      };
    })
    .filter((it) => it.institusjoner.length > 0);
};
